import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

import closeImg from '../../../images/icons/close.png';

import { setCheckedVersion } from '../../../actions/member';

import {
  FONT_MODE, NEW_VERSION,
} from '../../../constants/constants';

import config from '../../../constants/config';

const isInAppFrame = config.isInAppFrame();

class NewVersion extends React.Component {
  static propTypes = {
    newVersion: PropTypes.number,
    t: PropTypes.func.isRequired,
    setCheckedVersionFunc: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
    openChangeLogVersionModal: PropTypes.bool,
    closeTriggerChangeLogModal: PropTypes.func.isRequired,
    hidden: PropTypes.bool,
  }

  static defaultProps = {
    newVersion: null,
    fontMode: FONT_MODE.normal,
    openChangeLogVersionModal: false,
    hidden: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      version: NEW_VERSION || '3.10.1',
    };
  }

  closeModal = () => {
    const { closeTriggerChangeLogModal, setCheckedVersionFunc } = this.props;
    const { version } = this.state;
    closeTriggerChangeLogModal();
    setCheckedVersionFunc(version);
  }

  render() {
    const { newVersion, t, i18n, fontMode, setCheckedVersionFunc, openChangeLogVersionModal, hidden } = this.props;
    const { version } = this.state;

    console.log('newVersion modal', openChangeLogVersionModal, newVersion, version);

    if (hidden) {
      return null;
    }

    if ((!newVersion || newVersion >= version) && !openChangeLogVersionModal) {
      if (!newVersion) {
        console.log('setCheckedVersionFunc');
        setCheckedVersionFunc(version);
      }
      return null;
    }

    return (
      <Modal container={'div > div'} isOpen size="lg" className={`${isInAppFrame ? 'modal-is-app-frame' : ''} notification new-version-modal old-modal root-font-${fontMode}`}>
        <ModalHeader
          toggle={this.closeModal}
          className="notification-header"
          close={
            <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.closeModal} />
            }
        />
        <ModalBody className="notification-body">
          <div className="new-version-modal-scrollarea">
            {(!i18n.language || i18n.language === 'lv') ? (
              <>
                <h2 className="new-version-header">Sveiki, zolmaņi!</h2>
                <p className="new-version-body">Pēdējā laikā esam strādājuši pie kārtējā spēles atjauninājuma, kurā ir iekļauti šādi jaunumi un labojumi:</p>
                <ul className="new-version-body">
                  <li> Studentu zole tagad ir pieejama arī vecajā dizainā versijā.</li>
                  <li> Tagad ir iespēja nosūtīt uzaicinātajiem draugiem Zoles monētas.</li>
                  <li> Izlabotas vairākas kļūdas saistībā ar turnīriem.</li>
                  <li> Izbīdāmā sānu izvēlne pieejama arī Inbox versijā.</li>
                  <li> Novērstas problēmas ar e-pasta pievienošanu profilā.</li>
                  <li> Izlabotas problēmas ar pievienošanos istabām noteiktos gadījumos.</li>
                  <li> Veiksmes rata vēsturē pēdējais ieraksts parādījās novēloti.</li>
                  <li> Poga ‘Pēdējās partijas kāršu sadalījums’ netiek rādīts pirmajā istabas partijā.</li>
                  <li> Izlabota problēma ar pirkumu attēlošanu vecā izskata versijā.</li>
                  <li> Istabu sarakstā istabas ir vairāk izceltas.</li>
                  <li> Izlabota sasniegumu aprēķināšana Laimes rata iegriešanai.</li>
                  <li> Vecajā dizainā pie istabas dāvanam ir atgriezts "zārciņš".</li>
                </ul>
                <p className="new-version-body">Jūsu Zoles administrācija</p>
              </>
            ) : (null)}


            {(i18n.language === 'en') ? (
              <>
                <h2 className="new-version-header">Hello players!</h2>

                <p className="new-version-body">We've recently been working on a regular update to the game that includes the following news and fixes:</p>
                <ul className="new-version-body">
                  <li> Student Zole is now also available in the Old design version.</li>
                  <li> It is now possible to send Zole coins to invited friends.</li>
                  <li> Fixed several issues related to tournaments.</li>
                  <li> The slide-out side menu is also available in the Inbox version.</li>
                  <li> Resolved issues with adding an email address to the profile.</li>
                  <li> Fixed issues with joining rooms in certain cases.</li>
                  <li> The latest entry in the Lucky Wheel history was displayed with a delay.</li>
                  <li> The "Last Game" button is no longer shown during the first game in a game room.</li>
                  <li> Fixed an issue with purchase display in the Old design.</li>
                  <li> Rooms are now more visually highlighted in the room list.</li>
                  <li> Fixed achievement calculation for spinning the Lucky Wheel.</li>
                  <li> In the Old design, the "coffin" gift has been restored in the room gifts section.</li>
                </ul>
                <p className="new-version-body">Your Zole Administration</p>

              </>
            ) : (null)}



            {(i18n.language === 'ru') ? (
              <>
                <h2 className="new-version-header">Здравствуйте, уважаемый игрок!</h2>

                <p className="new-version-body">Недавно мы закончили работу над очередным обновлением игры, которое включает в себя следующие улучшения и исправления:</p>
                <ul className="new-version-body">
                  <li> Студенческая зола теперь доступна и в версии старого дизайна.</li>
                  <li> Теперь появилась возможность отправлять игровые монеты приглашённым друзьям.</li>
                  <li> Исправлены несколько ошибок, связанных с турнирами.</li>
                  <li> Выдвижное боковое меню теперь доступно также в Inbox версии игры.</li>
                  <li> Устранены проблемы с добавлением электронной почты в профиле.</li>
                  <li> Исправлена ошибка, приводящая к помехам в присоединении к игровым комнатам.</li>
                  <li> Последняя запись в истории Колеса удачи отображалась с задержкой.</li>
                  <li> Кнопка «Распределение карт в предыдущей партии» больше не отображается во время первой игры в комнате.</li>
                  <li> Исправлена проблема с отображением покупок в старом дизайне.</li>
                  <li> Строки в списке комнат теперь разделены четче.</li>
                  <li> Исправлены неточности в расчёте достижений за прокрутку Колеса удачи.</li>
                  <li> В старом дизайне в раздел подарков комнаты возвращён подарок «гробик».</li>
                </ul>
                <p className="new-version-body">Ваша администрация</p>
              </>
            ) : (null)}
          </div>
        </ModalBody>
        <ModalFooter className="notification-footer">
          <Button color="link" className="notification-footer-button" onClick={this.closeModal}>{t('common.ok')}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  newVersion: state.member.newVersion || null,
});

const mapDispatchToProps = {
  setCheckedVersionFunc: setCheckedVersion,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(NewVersion));
